export function hasCupContext(input) {
  const text = Array.isArray(input) ? input.join(" ") : String(input || "");
  if (!text.trim()) return false;
  return /(cup|knockout|tier[-\s]?gap|upset|elimination|extra\s*time|penalt)/i.test(text);
}

